var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recommend-start"},[_c('span',{staticClass:"start-grey",style:({width: ((5 - _vm.startNum) / 5)*100 + '%'})}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.twoFixed))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32ef6b44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecommendStart.vue
// module id = null
// module chunks = 